export class LFAttractScreensVO {
  attractSets: AttractScreenVO[];
  has307Software: boolean;
}

export class AttractScreenVO {
  setId: string;
  activityId?: number;
  backgroundColor?: string;
  consoleType: string;
  hasScrolling?: boolean;
  inUse?: boolean;
  message?: string;
  messageFontColor?: string;
  name?: string;
  publishedAt?: string;
  updatedAt?: string;
  images: AttractImageVO[];
  userId?: string;
  isEdited?: boolean;
  imageReordered?: boolean;
	hasImage?: boolean;
}

export class AttractImageVO {
  name?: string;
  height?: number;
  width?: number;
  url?: string;
  backgroundColor?: string;
}

export class AttractImage {
	id?: string;
	name?: string;
	userId?: string;
	originalFileName?: string;
	fileType?: string;
	sourceImageUrl?: string;
	seImageUrl?: string;
	siImageUrl?: string;
	thumbnailUrl?: string;
	seArchiveUrl?: string;
	siArchiveUrl?: string;
	sourceImageKey?: string;
	seImageKey?: string;
	siImageKey?: string;
	thumbnailKey?: string;
	seArchiveKey?: string;
	siArchiveKey?: string;
	rgb?: string;
	croppingX?: number;
	croppingY?: number;
	croppingW?: number;
	croppingH?: number;
	createdAt?: string;
	updatedAt?: string;
	sourceImageWidth?: number;
	sourceImageHeight?: number;
	inUse?: boolean;
	imageType?: string;
	consoleType?: string;
	actualCroppingParams?: string;
}

export class LFImageLibraryGroupingVO {	
	lfImageLibraries?: LFImageLibraryVO[];
}

export class LFImageLibraryVO {
  count: number
  type: string;
  name: string;
  imagesList: AttractImage[];
}

export class AttractScreenImageVO {	
	id?: string;
	name?: string;
	s3ObjectKey?: string;
	sourceImageUrl?: string;
	contentType?: string;
	orignalFileName?: string;
	croppingParam?: CroppingParamVO;
	attractScreenSICroppingParam?: CroppingParamVO;
	attractScreenSECroppingParam?: CroppingParamVO;
	enableBackgroundColor?: boolean;
	redRGB?: Number;
	greenRGB?: Number;
	blueRGB?: Number;
	imageType?: string;
	consoleType?: string;
  imageFile?: File;
  formData?: any;
}

export class CroppingParamVO {
  X?: number;
  Y?: number;
  W?: number;
  H?: number;
  uiH?: number;
  uiW?: number;
  uiX?: number;
  uiY?: number;
}

export class SaveAttractScreenVO {
  attractSet: AttractSet;
  facilityIds: string[];
  isReordered: boolean;
}

export class ApplyAttractScreen {
	facilityIds: string[];
	activityIds?: string[];
	consoleType?: string;
	isApply: boolean;
	attractScreen: AttractSet;
	assetIds: string[];
	isReordered: boolean;
}

export class AttractSet {
	id: string;
	name: string;
	userId: string;
	firstImage: AttractImage;
	secondImage: AttractImage;
	thirdImage: AttractImage;
	fourthImage: AttractImage;
	fifthImage: AttractImage;
	createdAt: string;
	updatedAt: string;
  publishedAt: string;
	inUse: boolean;
	message: string;
	messageColor: string;
	backgroundColor: string;
	hasScrolling: boolean;
  consoleType: string;
  activityIdList: string;
}